export const MODAL_TYPES = {
  VERIFY: 'VERIFY',
  VALID: 'VALID',
  INVALID: 'INVALID',
  INVALID_DOCUMENT: 'INVALID_DOCUMENT',
};

export const CHECKLIST = [
  'Max file size: 10 MB',
  'File type: .png, .jpeg, .jpg',
];

export const FILE_TYPE = 'image/*';

export const REQUIRED_FIELDS = ['aadhaar_image'];
